export default __webpack_public_path__ + "static/Pivottable.f664e00203a726d787f87dc57ad63cb2.svg";